import cloneDeep from 'lodash/cloneDeep'
import { INIT_RESOURCES, INCREASE_RESOURCES } from '../../actions/game/resources.actions'
import { mergeObjects } from '../../../utils/helper'

const initialState = {
    GOLD: 0,
    CRYST: 0,
}
const initialResources = {
    GOLD: 100,
    CRYST: 0,
}

const resourcesReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case INIT_RESOURCES: {
            return initialResources
        }

        case INCREASE_RESOURCES: {
            const { resources } = payload
            return mergeObjects(cloneDeep(state), resources)
        }

        default: {
            return state
        }
    }
}

export default resourcesReducer
